import React, { useState, useEffect, useRef } from 'react'

import {
    useTableSelectedRows,
    useTableSelectAllState,
    useTableFilters,
} from '../../../redux/selectors'

import BPMTableCell from './BPMTableCell'

import { Checkbox, TableCell, TableRow } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const CustomBodyTableCell = withStyles(() => ({
    root: {
        padding: "0px 0px 0px 10px",
        '&:last-child': {
            paddingRight: '5px',
        },
    },
}))(TableCell)

const BPMTableRow = (props) => {
    const {
        onRowClickAction,
        data,
        TableObject,
        classes,
        checkboxDisplay,
        filtersDisplay,
        preColumnDisplay,
        handleClickCheckBox,
        refreshTable,
    } = props

    const [selected, setSelected] = useState(false)
    const [mounted, setMounted] = useState(false)
    const ref = useRef()

    const selectedRows = useTableSelectedRows(TableObject.tableName)
    const allRowsSelected = useTableSelectAllState(TableObject.tableName)
    const filters = useTableFilters(TableObject.tableName)

    useEffect(() => {
        setMounted(true)

        return () => {
            setMounted(false);
        };
    }, []);

    useEffect(() => {
        setSelected(isSelected())
    }, [allRowsSelected, selectedRows, filters, data]);

    const isSelected = () => {
        const rowSelected = selectedRows.find(item => item.id === data.id)
        return allRowsSelected ? rowSelected === undefined : rowSelected !== undefined
    }

    const isReadOnlyRow = () => {
        return (TableObject.readOnlyRowEvaluator ? TableObject.readOnlyRowEvaluator(data) : false)
    }

    const getcustomRowStyle = () => {
        return TableObject.customRowStyleEvaluator ? TableObject.customRowStyleEvaluator(data) : {}
    }

    const getCustomCellStyle = (id) => {
        return TableObject.customCellStyleEvaluator ? TableObject.customCellStyleEvaluator(id, data) : {}
    }

    return (
        <TableRow
            style={{ height: TableObject.defaultRowHeight, ...getcustomRowStyle()}}
            hover
            role='checkbox'
            aria-checked={selected}
            tabIndex={-1}
            key={'tableRow_' + data.id}
            selected={selected}
            onClick={(event) => {
                event.stopPropagation();
                onRowClickAction(data);
            }}
        >
            {preColumnDisplay && (TableObject.getfiltersDisplay(filtersDisplay) || checkboxDisplay) ?
                <CustomBodyTableCell padding='checkbox' style={{ width: 50, paddingLeft: '20px', textAlign: 'left' }} key={'checkbox' + data.id}>
                    {checkboxDisplay &&
                        <Checkbox
                            checked={selected}
                            color='primary'
                            style={{ padding: 0 }}
                            ref={ref}
                            onClick={event => {
                                event.stopPropagation()
                                handleClickCheckBox(event, data, ref)
                                setSelected(!selected)
                            }}
                        />
                    }
                </CustomBodyTableCell>
                : null
            }
            {
                TableObject.fieldDescriptions.map(fieldDescription => {
                    const key = "cell" + fieldDescription.id + '_' + data.id;
                    return (
                        <BPMTableCell
                            key={key}
                            data={data}
                            fieldDescription={fieldDescription}
                            classes={classes}
                            tableName={TableObject.tableName}
                            customCellStyle={getCustomCellStyle(fieldDescription.id)}
                            rowHeight={TableObject.defaultRowHeight}
                        />
                    )
                })
            }
            {(() => {
                const actionsConfig = TableObject.getRowActionButtonsConfig()
                const count = Math.min(3, (actionsConfig && actionsConfig.length) ? actionsConfig.length : 1)
                const perButton = 44
                const minWidth = 50
                const actionsColWidth = Math.max(minWidth, count * perButton)
                return (
                    <CustomBodyTableCell style={{ whiteSpace: 'nowrap', textAlign: 'right', paddingRight: '8px', width: actionsColWidth }}>
                        {/* Strategy call — Row action buttons display family (BaseRowActionButtonsDisplayStrategy): createWith(config, rowData, ctx). Concrete: TableObject.rowActionButtonsContainerCreator (default: DefaultActionButtonsContainerCreator) */}
                        { TableObject.rowActionButtonsContainerCreator.createWith(
                            actionsConfig,
                            data,
                            { readOnly: isReadOnlyRow(), TableObject, refreshTable }
                        )}
                    </CustomBodyTableCell>
                )
            })()}
        </TableRow>
    )
}

export default BPMTableRow
